var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo"},[_c('h1',[_vm._v("PHOTO")]),_c('img',{attrs:{"src":_vm.currentPhoto},on:{"click":function($event){return _vm.goPhoto(_vm.currentIndex++)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }